import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { ActivityNode } from './activity-message/activity-run';

export type ChatActivityMessageProps = {
  activity: ActivityFeed;
};

/**
 * One activity in the chat timeline. `ActivityNode` decides between a plain row and an expandable
 * run, and owns the recursion for anything nested inside it.
 */
export const ChatActivityMessage = ({ activity }: ChatActivityMessageProps) => (
  <ActivityNode activity={activity} />
);
